import { useSelector } from 'react-redux';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getDeviationUrl, getDeviationResourceType, } from '../../DeviationViews/_helpers';
import { ResourceType } from '../../types/resource';
import { getBiContentViewStatus } from '../../DeviationPage/redux/selectors';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
function useBiDataForDeviationLink(deviation) {
    var contentViewStatus = useSelector(function (state) { return deviation && getBiContentViewStatus(state, deviation); });
    var _a = useSubscriptionTier(deviation), needsSubscription = _a.needsSubscription, isSubscribedButBlocked = _a.isSubscribedButBlocked;
    var biData = {
        evid: BiEventType.ITEM_CLICK,
        href: deviation && getDeviationUrl(deviation),
        typeid: deviation && getDeviationResourceType(deviation),
        itemid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId,
    };
    if (needsSubscription || isSubscribedButBlocked) {
        biData.content_view_status = 'subscription_locked';
    }
    else {
        biData.content_view_status = contentViewStatus;
    }
    if (deviation === null || deviation === void 0 ? void 0 : deviation.author) {
        biData.creatorid = deviation === null || deviation === void 0 ? void 0 : deviation.author.useridUuid;
    }
    if ((deviation === null || deviation === void 0 ? void 0 : deviation.typeId) === ResourceType.TIER) {
        biData.evid = BiEventType.VIEW_TIER_UNIQUE;
    }
    return biData;
}
export default useBiDataForDeviationLink;
//# sourceMappingURL=useBiDataForDeviationLink.js.map